import { useTranslation } from '@hotjar/translations';
import { Button, Tooltip } from '@hotjar/hotsauce';
import { useState } from 'react';
import { useSubscriptionStatus } from '@hotjar/subscription-management';
import { useCurrentUser } from '@hotjar/user';
import { usePermissionWithDependencies as usePermission } from '@hotjar/auth';
import { StyledField, Wrapper } from '../styles';
import { DeleteAccountModal } from './DeleteAccountModal';

export const ExtremeMeasures = (): JSX.Element => {
  const { t } = useTranslation('profile');
  const [isModalOpen, setModalState] = useState(false);

  const { data: currentUser } = useCurrentUser();
  const currentAccountId = currentUser?.accounts?.[0].id;

  const canManageSubscription = usePermission(
    'subscriptions-manage',
    currentUser?.id,
    currentAccountId,
  );
  const { data: subscriptionStatus } = useSubscriptionStatus(currentAccountId, {
    enabled: canManageSubscription,
  });

  const hasActiveSubscription = canManageSubscription && subscriptionStatus?.status === 'ACTIVE';

  return (
    <Wrapper>
      <DeleteAccountModal isOpen={isModalOpen} onClose={() => setModalState(false)} />
      <StyledField labelText={t('extreme-measures.title')} inputId="profile-delete-button">
        <Tooltip
          text={t('extreme-measures.delete-active-subscription')}
          isDisabled={!hasActiveSubscription}
        >
          <span>
            <Button
              id="profile-delete-button"
              onClick={() => setModalState(true)}
              type="button"
              kind="danger"
              icon="trash"
              isDisabled={hasActiveSubscription}
            >
              {t('extreme-measures.delete')}
            </Button>
          </span>
        </Tooltip>
      </StyledField>
    </Wrapper>
  );
};
